import React from 'react'

const Updateprofile = () => {
  return (
    <div>Updateprofile</div>
  )
}

export default Updateprofile